/**
 * The shared "N Sparks to go" caption both `BadgeCard` and `BadgeOverlayDetailsContainer` need for a
 * locked badge that's its ladder's own next tier. Split into its own leaf module, beside
 * `categoryLabels.ts` on the shared `components/Badges/` shelf: the overlay is a container and the
 * card is presentational, so neither can import the other without inverting the dependency
 * (overview-rebuild-pr3-plan.md "One helper owns the points string"). Import this module by its own
 * direct path, never through a barrel — jest resolves no path aliases here, so a barrel import would
 * make every suite that needs one shared string mock the whole barrel to reach it.
 *
 * `pointsToNext` is never `0` on real data — `computeLadderTier`
 * (`api/app/services/awardEngine.service.ts:65-80`) has exactly three branches, and the two that yield
 * a non-null `points_to_next` both compute it as a strictly-positive difference; the third yields
 * `null` (overview-rebuild-pr3-plan.md "The zero that cannot happen"). This renders the number
 * unconditionally rather than guarding a state no data can produce — correct if the invariant ever
 * changes, and the invariant itself is recorded here, not assumed silently.
 *
 * @param pointsToNext - points remaining to the badge's ladder's next tier, or `null` when the badge
 * isn't a next-tier progress card.
 * @returns e.g. `"230 Sparks to go"`, or `null` when there's nothing to caption.
 */
export const pointsToNextCaption = (pointsToNext: number | null): string | null =>
  pointsToNext === null ? null : `${pointsToNext} Sparks to go`;
